import GsTree from "./gs-tree.vue"
const component = {
  install: (Vue) => {
    Vue.component('GsTree', GsTree)
  }
}
export default component